import type { AdaptiveScanningStateDto } from './adaptive-scanning.schema';

export const ADAPTIVE_SCANNING_POLL_INTERVAL_MS = 10_000;

const AUTO_RESUME_POLL_GRACE_MS = 2 * 60 * 1000;

const ACTIVE_POLL_PHASES = new Set([
  'discovering',
  'attack_ready',
  'attacking',
  'resume_verification',
]);

export const adaptiveScanningPollInterval = ({
  state,
  now = Date.now(),
}: {
  state: Pick<AdaptiveScanningStateDto, 'phase' | 'autoResumeAt'> | undefined;
  now?: number;
}): number | false => {
  if (!state?.phase) {
    return false;
  }

  if (ACTIVE_POLL_PHASES.has(state.phase)) {
    return ADAPTIVE_SCANNING_POLL_INTERVAL_MS;
  }

  if (state.phase !== 'paused_blocked' || !state.autoResumeAt) {
    return false;
  }

  const dueAt = new Date(state.autoResumeAt).getTime();

  if (Number.isNaN(dueAt) || now > dueAt + AUTO_RESUME_POLL_GRACE_MS) {
    return false;
  }

  return ADAPTIVE_SCANNING_POLL_INTERVAL_MS;
};
